import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';

import { trackByFunctions } from '@assess/browser/track-by-functions';
import { Nullable } from '@assess/shared/type-utilities';

@Component({
  selector: 'assess-expandable-list',
  templateUrl: './expandable-list.component.html',
  styleUrls: ['./expandable-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableListComponent {
  @Input() items: any[] | null = [];
  @Input() viewMoreLabel = 'View All';
  @Input() viewLessLabel = 'View Less';
  @ContentChild(TemplateRef, { static: false }) listItemTemplate!: TemplateRef<any>;
  @Input() visibleItems = 3;
  @Input() hideFormCentricComponents!: Nullable<boolean>;
  @Input() displaySubmissionHistory!: Nullable<boolean>;

  showMore = false;
  readonly trackByIndex = trackByFunctions.byIndex;

  onToggleShowMore() {
    this.showMore = !this.showMore;
  }
}
